let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bipKV")).then(() => parcelRequire('292f2'));